'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link'; // Importa il componente Link di Next.js
import { client } from '../../sanity/lib/client';

interface FooterLink {
    title: string;
    url: string | null;  // L'URL può essere una stringa o null
}

interface FooterSection {
    title: string;
    links: FooterLink[];
}

interface FooterData {
    sections: FooterSection[];
    copyright: string;
    socialLinks: FooterLink[];
}

const Footer: React.FC = () => {
    const [footerData, setFooterData] = useState<FooterData | null>(null);

    const query = `*[_type == "footer"][0]{
                      sections[]->{
                        title,
                        links[]{
                          title,
                          url
                        }
                      },
                      copyright,
                      socialLinks[]{
                        title,
                        url
                      }
                    }`;

    useEffect(() => {
        client.fetch<FooterData>(query).then((data) => setFooterData(data));
    }, []);

    if (!footerData) return <div></div>;

    return (
        <footer className="border border-t bg-gray-50 py-10">
            <div className="container">
                <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
                    {footerData.sections.map((section, index) => (
                        <div key={index} className="space-y-3">
                            <h3 className="font-bold">{section.title}</h3>
                            <ul className="space-y-2">
                                {section.links.map((link, idx) => (
                                    link.url ? ( // Verifica che l'URL esista prima di renderizzare il Link
                                        <li key={idx}>
                                            <Link hrefLang="it" href={link.url} title={link.title}>
                                                <span
                                                    className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-base font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 cursor-pointer hover:underline underline-offset-4">
                                                    {link.title}
                                                </span>
                                            </Link>
                                        </li>
                                    ) : null // Se l'URL è null, non renderizza nulla
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
                <p className="text-xs font-normal sm:text-sm sm:font-normal mt-10 text-center sm:text-left">
                    {footerData.copyright}
                </p>
                <ul className="flex items-center gap-lg mt-lg">
                    {footerData.socialLinks.map((social, index) => (
                        social.url ? (
                            <li key={index}>
                                <Link hrefLang="it" href={social.url} title={social.title}>
                                    <span className="group inline-flex items-center space-x-2">

                                    </span>
                                </Link>
                            </li>
                        ) : null
                    ))}
                </ul>
            </div>
        </footer>
    );
};

export default Footer;
